import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarAsesoria } from '../../actions/asesorias';

const EliminarAsesoria = ({ asesoria, reestablecerAsesoria }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar asesoria */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarAsesoria(asesoria?._id));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerAsesoria(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(asesoria != null){
            setEliminarModal(true);
        }
    }, [asesoria]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar asesoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar la asesoría de {asesoria?.cliente} del {asesoria?.creacion ? new Date(asesoria?.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : ''}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarAsesoria;